import {
  addObj,
  getAll,
  searchByName,
  getPage,
  getDetail,
  modifyObj,
  deleteObj
} from '@/api/gnssreportserv'

export default {
  state: {
    state_GnssReport_AddObjResult: null,
    state_GnssReport_GetAllResult: null,
    state_GnssReport_SearchByNameResult: null,
    state_GnssReport_GetPageResult: null,
    state_GnssReport_GetDetailResult: null,
    state_GnssReport_ModifyObjResult: null,
    state_GnssReport_DeleteObjResult: null
  },
  mutations: {
    SET_GNSSREPORT_ADDOBJ_RESULT: (state, rst) => {
      state.state_GnssReport_AddObjResult = rst
    },
    SET_GNSSREPORT_GETALL_RESULT: (state, rst) => {
      state.state_GnssReport_GetAllResult = rst
    },
    SET_GNSSREPORT_SEARCHBYNAME_RESULT: (state, rst) => {
      state.state_GnssReport_SearchByNameResult = rst
    },
    SET_GNSSREPORT_GETPAGE_RESULT: (state, rst) => {
      state.state_GnssReport_GetPageResult = rst
    },
    SET_GNSSREPORT_GETDETAIL_RESULT: (state, rst) => {
      state.state_GnssReport_GetDetailResult = rst
    },
    SET_GNSSREPORT_MODIFYOBJ_RESULT: (state, rst) => {
      state.state_GnssReport_ModifyObjResult = rst
    },
    SET_GNSSREPORT_DELETEOBJ_RESULT: (state, rst) => {
      state.state_GnssReport_DeleteObjResult = rst
    }
  },
  actions: {
    GnssReportServ_AddObj ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        addObj(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_GNSSREPORT_ADDOBJ_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_GNSSREPORT_ADDOBJ_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    GnssReportServ_GetAll ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_GNSSREPORT_GETALL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_GNSSREPORT_GETALL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    GnssReportServ_SearchByName ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        searchByName(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_GNSSREPORT_SEARCHBYNAME_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_GNSSREPORT_SEARCHBYNAME_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    GnssReportServ_GetPage ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_GNSSREPORT_GETPAGE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_GNSSREPORT_GETPAGE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    GnssReportServ_GetDetail ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_GNSSREPORT_GETDETAIL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_GNSSREPORT_GETDETAIL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    GnssReportServ_ModifyObj ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        modifyObj(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_GNSSREPORT_MODIFYOBJ_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_GNSSREPORT_MODIFYOBJ_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    GnssReportServ_DeleteObj ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        deleteObj(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_GNSSREPORT_DELETEOBJ_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_GNSSREPORT_DELETEOBJ_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    }
  },
  getters: {
    get_GnssReport_AddObjResult: state => {
      return state.state_GnssReport_AddObjResult
    },
    get_GnssReport_GetAllResult: state => {
      return state.state_GnssReport_GetAllResult
    },
    get_GnssReport_SearchByNameResult: state => {
      return state.state_GnssReport_SearchByNameResult
    },
    get_GnssReport_GetPageResult: state => {
      return state.state_GnssReport_GetPageResult
    },
    get_GnssReport_GetDetailResult: state => {
      return state.state_GnssReport_GetDetailResult
    },
    get_GnssReport_ModifyObjResult: state => {
      return state.state_GnssReport_ModifyObjResult
    },
    get_GnssReport_DeleteObjResult: state => {
      return state.state_GnssReport_DeleteObjResult
    }
  }
}
